import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule, NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule, SvgIconComponent } from 'angular-svg-icon';
import { EllipsisModule } from 'ngx-ellipsis';
import { AccordionDirective } from './common/directives/accordion/accordion.directive';
import { DebounceClickDirective } from './common/directives/debounce-click/debounce-click.directive';
import { DebounceKeyboardKeyUpDirective } from './common/directives/debounce-keyboard-input/debounce-keyboard-keyup.directive';
import { FileDownloadingDirective } from './common/directives/file-download/download.directive';
import { ImagePreloadDirective } from './common/directives/image-preload/image-preload.directive';
import { LongOperationDirective } from './common/directives/long-operations/long-operations.directive';
import { OperationManagedControlDirective } from './common/directives/operation-managed-control/operation-managed-control.directive';
import { PipesModule } from './common/pipes/pipes.module';
import { SmallProfileImageComponent } from './components/profile/profile-image/small-profile-image/small-profile-image.component';
import { ProfileLinkComponent } from './components/profile/profile-link/profile-link.component';
import { PublicLinkComponent } from './components/profile/public-link/public-link.component';
import { DotdotdotComponent } from './components/shared/dotdotdot/dotdotdot.component';
import { PageHeaderTitle } from './components/shared/header-title/header-title.component';
import { PieChartComponent } from './components/shared/pie-chart/pie-chart.component';
import { SearchInputComponent } from './components/shared/search-input/search-input.component';
import { TableConstructorDirective } from './components/tables/directive/table-consctructor.directive';

@NgModule({
  imports: [CommonModule, RouterModule, TranslateModule, EllipsisModule, PipesModule, AngularSvgIconModule],
  declarations: [
    ImagePreloadDirective,
    DebounceClickDirective,
    AccordionDirective,
    DebounceKeyboardKeyUpDirective,
    FileDownloadingDirective,
    TableConstructorDirective,
    OperationManagedControlDirective,
    LongOperationDirective,
    PublicLinkComponent,
    SmallProfileImageComponent,
    ProfileLinkComponent,
    PageHeaderTitle,
    DotdotdotComponent,
    PieChartComponent,
    SearchInputComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NgbModule,
    NgbModalModule,
    NgbDropdownModule,
    RouterModule,
    AccordionDirective,
    ImagePreloadDirective,
    DebounceClickDirective,
    DebounceKeyboardKeyUpDirective,
    FileDownloadingDirective,
    TableConstructorDirective,
    OperationManagedControlDirective,
    LongOperationDirective,
    PublicLinkComponent,
    SmallProfileImageComponent,
    ProfileLinkComponent,
    PageHeaderTitle,
    DotdotdotComponent,
    PieChartComponent,
    SearchInputComponent,
    SvgIconComponent,
  ],
})
export class SharedModule {
  public static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
    };
  }
}
